import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import SurveyIndex from "./pages/surveys/SurveyIndex";
import Survey from "./pages/surveys/SurveyContainer";
import SurveyModuleDetail from "./pages/surveys/SurveyModuleDetail";
import ProcedureClientOld from "./pages/procedures/ProcedureClientOld";
import { default as ProfileForm } from "./pages/users/Form";
import RescuePassword from "./pages/passwords/RescuePassword";
import ChangePassword from "./pages/passwords/ChangePassword";
import Oauth from "./pages/Oauth";
import Policy from "./pages/policy/Policy";
import PolicyUax from "./pages/policy/PolicyUax";
import PolicyUAXMN from "./pages/policy/PolicyUAXMN";

import Disclaimer from "./pages/disclaimer/Disclaimer";
import DisclaimerUax from "./pages/disclaimer/DisclaimerUax";
import DisclaimerUAXMN from "./pages/disclaimer/DisclaimerUAXMN";

import Profile from "./pages/users/Profile";
import Wrapper from './components/Wrapper';
import routes from "./config/routes";
import Proctoring from './pages/proctoring/Proctoring'
import DemoStaticPage from './pages/demo/demoComponent'
import { useParams, useLocation, useNavigate } from 'react-router-dom';
function App() {
  const navigate = useNavigate();
  return (
    <Routes>
      {/* Ruta pública */}
      <Route path="/login" element={<Login />} />
      <Route path={routes.client.profileSignin} element={<ProfileForm />} />
      <Route path={routes.client.rescuePassword} element={<RescuePassword />} />
      <Route path={routes.client.changePassword} element={<ChangePassword />} />
      <Route path={routes.client.oauth} element={<Oauth />} />

      {/* Policy */}
      <Route path={routes.client.policy} element={<Policy />} />
      <Route path={routes.client.policy_uax} element={<PolicyUax />} />
      <Route path={routes.client.policy_uaxmn} element={<PolicyUAXMN />} />
      {/* Disclaimer */}
      <Route path={routes.client.disclaimer} element={<Disclaimer />} />
      <Route path={routes.client.disclaimer_uax} element={<DisclaimerUax />} />
      <Route path={routes.client.disclaimer_uaxmn} element={<DisclaimerUAXMN />} />
      <Route path={routes.client.demo} element={<DemoStaticPage />} />

      {/* Ruta protegida */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Wrapper />}>
          <Route path="/" element={<Navigate to={routes.client.surveys} replace />} />
          <Route path={routes.client.survey_module} element={<SurveyModuleDetail />} />
          <Route path={routes.client.survey} element={<Survey />} />
          <Route path={routes.client.surveys} element={<SurveyIndex />} />
          <Route path={routes.client.procedure} element={<ProcedureClientOld />} />
          <Route path={routes.client.myProfile} element={<Profile />} />
          <Route path={routes.client.checkproctoring} element={<Proctoring onSuccess={() => navigate("/surveys")} />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
